import { Link } from 'react-router-dom';
import ScrollReveal from '@/components/feature/ScrollReveal';

export default function SiteFooter() {
  return (
    <footer className="bg-white">
      {/* Background image strip */}
      <div
        className="w-full"
        style={{
          height: '380px',
          backgroundImage: 'url(https://scontent-den2-1.cdninstagram.com/v/t1.15752-9/661181761_1565054625627006_4826201944380233513_n.jpg?stp=dst-jpg_e15_tt6&_nc_cat=107&ccb=7-5&_nc_sid=fc17b8&efg=eyJxZV9ncm91cHMiOlsiaWdkX2Jlc3RfZWZmb3J0X2ltYWdlOnRlc3QiXX0%3D&_nc_ohc=OSMtMf0igzQQ7kNvwFH2s4C&_nc_oc=AdpPLrIKF2oGgbFuzdWfYJ1NjR45a7C2pbViaQQ-Tngt2p947EtVLvpvPtpKrVoa-0Q&_nc_zt=23&_nc_ht=scontent-den2-1.cdninstagram.com&_nc_ss=7a3a8&oh=03_Q7cD5AENv6B-CF2UbT3VZGF6Efm_9ZRbO-IEo87WiJJKUPButw&oe=69F37052)',
          backgroundSize: 'cover',
          backgroundPosition: 'center 25%',
        }}
      />

      {/* Top divider */}
      <div className="border-t border-black/10" />

      {/* Footer content */}
      <div className="px-6 md:px-12 lg:px-16 py-12 md:py-16">
        <div className="flex flex-col md:flex-row justify-between gap-10">
          {/* Left: Brand + contact */}
          <ScrollReveal direction="up" duration={800} distance={32} className="flex flex-col gap-5">
            <div>
              <Link
                to="/"
                className="text-black text-xl md:text-2xl cursor-pointer"
                style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700 }}
              >
                NOVA AI DIGITAL
              </Link>
            </div>

            {/* Social icons */}
            <div className="flex items-center gap-4">
              <a
                href="https://www.instagram.com/novaaidigitalllc/"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Instagram"
                className="cursor-pointer"
              >
                <i className="ri-instagram-line text-black text-lg hover:opacity-50 transition-opacity" />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61580586208643"
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label="Facebook"
                className="cursor-pointer"
              >
                <i className="ri-facebook-fill text-black text-lg hover:opacity-50 transition-opacity" />
              </a>

            </div>

            <div className="flex flex-col gap-1">
              <a
                href="tel:+19512909947"
                className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                (951) 290-9947
              </a>
              <a
                href="mailto:Ceobryantorres@novaaiwebsites.com"
                className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                Ceobryantorres@novaaiwebsites.com
              </a>
              <p className="text-sm text-black" style={{ fontFamily: 'Inter, sans-serif' }}>
                Southern California, CA
              </p>
            </div>
          </ScrollReveal>

          {/* Right: Links + copyright */}
          <ScrollReveal direction="up" delay={150} duration={800} distance={32} className="flex flex-col gap-4">
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>Home</Link>
              <Link to="/about" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>About</Link>
              <Link to="/services" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>Services</Link>
              <Link to="/pricing" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>Pricing</Link>
              <Link to="/work" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>Our Work</Link>
              <Link to="/contact" className="text-sm text-black hover:opacity-50 transition-opacity cursor-pointer" style={{ fontFamily: 'Inter, sans-serif' }}>Contact</Link>
            </div>

            <p className="text-sm text-black/40 mt-4" style={{ fontFamily: 'Inter, sans-serif' }}>
              &copy; 2025 by NOVA AI DIGITAL. Veteran Owned &amp; Operated.
            </p>
          </ScrollReveal>
        </div>
      </div>

      {/* Bottom divider */}
      <div className="border-t border-black/10" />
    </footer>
  );
}
